import React from "react";
import { Button } from "antd";
import styles from "./footer.module.css";

interface FooterProps {
    onCancel: () => void;
    onSave: () => void;
    loading: boolean;
}

export const Footer = ({ onCancel, onSave, loading }: FooterProps) => (
    <div className={styles.footer}>
        <Button className={styles.cancelButton} onClick={onCancel} disabled={loading}>
            <span className={styles.btnText}>Cancel</span>
        </Button>
        <Button
            className={styles.registerButton}
            onClick={onSave}
            loading={loading}
            disabled={loading}
        >
            <span className={styles.btnText}>Register</span>
        </Button>
    </div>
);
